var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-container body-container" }, [
    _c(
      "div",
      { staticClass: "body-header" },
      [
        _c("el-page-header", {
          attrs: { content: "报告详情" },
          on: { back: _vm.goBack },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "body-main" }, [
      _c(
        "div",
        { staticClass: "report-nav" },
        [
          _c(
            "el-scrollbar",
            { attrs: { "wrap-class": "scrollbar-wrapper" } },
            [
              _c(
                "el-menu",
                {
                  attrs: {
                    "default-active": _vm.activeMenu,
                    "background-color": _vm.variables.menuBg,
                    "text-color": _vm.variables.menuText,
                    "unique-opened": true,
                    "active-text-color": _vm.variables.menuActiveText,
                    "collapse-transition": false,
                    mode: "vertical",
                  },
                },
                _vm._l(_vm.reportNavList, function (route) {
                  return _c("nav-item", {
                    key: route.name,
                    attrs: {
                      item: route,
                      "project-id": _vm.projectId,
                      "report-id": _vm.reportId,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "report-content" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [
                _vm._v(_vm._s(_vm.projectInfo.game_name)),
              ]),
              _c("el-breadcrumb-item", [
                _vm._v(_vm._s(_vm.reportInfo.inform_name)),
              ]),
              _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$route.meta.title))]),
            ],
            1
          ),
          _vm._t("default", null, {
            projectInfo: _vm.projectInfo,
            reportInfo: _vm.reportInfo,
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }